'use strict';

/**
 * Module definition file
 *
 * All services, controllers, and directives are registered with angular here
 */

var analytics = angular.module('saturn.analytics', []);

var AnalyticsProvider = require('./AnalyticsProvider');

analytics.provider('sbAnalytics', AnalyticsProvider);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/analytics/src/index.js